
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class BlogTitleController extends Controller {

	/**
	* I highlight the text of the blog post title.
	*/
	highlight( event ) {

		var range = document.createRange();
		range.selectNode( this.element );

		var selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange( range );

	}

}
